import { StyleSheet } from 'aphrodite';
import { destructive, destructiveHoverLight, titles, white } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	menu: {
		position: 'fixed',
		backgroundColor: white,
		borderRadius: 8,
		boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15), 0 2px 8px rgba(0, 0, 0, 0.08)',
		padding: 8,
		minWidth: 200,
		maxWidth: 280,
		zIndex: 10000,
		border: '1px solid #e5e7eb',
	},
	menuItem: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		width: '100%',
		padding: '8px 10px',
		border: 'none',
		borderRadius: 4,
		backgroundColor: 'transparent',
		fontSize: 13,
		color: titles,
		cursor: 'pointer',
		transition: 'all 0.15s ease',
		textAlign: 'left' as const,
		':hover': {
			backgroundColor: '#f3f4f6',
		},
	},
	menuItemDanger: {
		color: destructive,
		':hover': {
			backgroundColor: destructiveHoverLight,
		},
	},
	protectedMessage: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		padding: '8px 10px',
		fontSize: 12,
		color: '#9ca3af',
		fontStyle: 'italic',
	},
});
